export default "__VITE_ASSET__55e042b5__"